import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import useAnalytics from '../analytics/useAnalytics';
import { EVT_INSTITUTE_MARKETING_VIEW } from '../analytics/events';
import useInstitutes from './institute/hooks/useInstitutes';
import ScrollProgressBar from './components/ScrollProgressBar';
import MarketingHeader from './sections/MarketingHeader';
import HeroSection from './institute/sections/HeroSection';
import SocialProofStrip from './institute/sections/SocialProofStrip';
import ProblemsSection from './institute/sections/ProblemsSection';
import BenefitsSection from './institute/sections/BenefitsSection';
import FeaturesSection from './institute/sections/FeaturesSection';
import HowItWorksSection from './institute/sections/HowItWorksSection';
import PricingSection from './institute/sections/PricingSection';
import FeaturedInstitutesSection from './institute/sections/FeaturedInstitutesSection';
import FaqSection from './institute/sections/FaqSection';
import SignupSection from './institute/sections/SignupSection';
import MarketingFooter from './sections/MarketingFooter';

function JoinUsAsInstitute() {
  const { track } = useAnalytics();
  const tracked = useRef(false);

  const { totalCount, uniqueCities, uniqueCourses, topInstitutes, loading } = useInstitutes();

  useEffect(() => {
    document.title = 'Join BookMyLibrary — List your institute';
    if (!tracked.current) {
      tracked.current = true;
      track(EVT_INSTITUTE_MARKETING_VIEW);
    }
  }, [track]);

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <ScrollProgressBar />
      <MarketingHeader ctaLabel="List your institute" />
      <HeroSection totalCount={totalCount} />
      <SocialProofStrip
        totalCount={totalCount}
        uniqueCities={uniqueCities}
        uniqueCourses={uniqueCourses}
        loading={loading}
      />
      <ProblemsSection />
      <BenefitsSection />
      <FeaturesSection />
      <HowItWorksSection />
      <PricingSection />
      <FeaturedInstitutesSection institutes={topInstitutes} loading={loading} />
      <FaqSection />
      <SignupSection />
      <MarketingFooter />
    </Box>
  );
}

export default JoinUsAsInstitute;
